<div
  class="color-picker"
  [hidden]="!show"
  [style.visibility]="this.hidden ? 'hidden' : 'visible'"
  [style.height.px]="cpHeight"
  [style.width.px]="cpWidth"
  [style.top.px]="top"
  [style.left.px]="left"
  [style.position]="position"
  #dialogPopup
>
  <div
    [rtColorPickerSlider]
    [style.background-color]="hueSliderColor"
    [rgX]="1"
    [rgY]="1"
    (newValue)="
      setSaturationAndBrightness({ s: $event.s!, v: $event.v!, rgX: $event.rgX!, rgY: $event.rgY! })
    "
    class="saturation-lightness"
  >
    <div [style.left.px]="slider.s" [style.top.px]="slider.v" class="cursor"></div>
  </div>
  <div class="box">
    <div class="left">
      <div class="selected-color-background"></div>
      <div [style.background-color]="selectedColor" class="selected-color"></div>
    </div>
    <div class="right">
      <div *ngIf="cpAlphaChannel === 'disabled'" style="height: 18px"></div>

      <div
        [rtColorPickerSlider]
        [rgX]="1"
        (newValue)="setHue({ v: $event.v!, rg: $event.rg! })"
        class="hue"
        #hueSlider
      >
        <div [style.left.px]="slider.h" class="cursor"></div>
      </div>

      <div
        [hidden]="cpAlphaChannel === 'disabled'"
        [rtColorPickerSlider]
        [style.background-color]="alphaSliderColor"
        [rgX]="1"
        (newValue)="setAlpha({ v: $event.v!, rg: $event.rg! })"
        class="alpha"
        #alphaSlider
      >
        <div [style.left.px]="slider.a" class="cursor"></div>
      </div>
    </div>
  </div>

  <div layout-horizontal>
    <div class="color-inputs-wrapper">
      <div [hidden]="format !== 2" class="hsla-text">
        <div class="box">
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="360"
            [rg]="360"
            (newValue)="setHue($event)"
            [value]="hslaText.h"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="100"
            [rg]="100"
            (newValue)="setSaturation($event)"
            [value]="hslaText.s"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="100"
            [rg]="100"
            (newValue)="setLightness($event)"
            [value]="hslaText.l"
          />
          <input
            *ngIf="cpAlphaChannel !== 'disabled'"
            [rtColorPickerText]
            type="number"
            pattern="[0-9]+([\.,][0-9]{1,2})?"
            min="0"
            max="1"
            step="0.1"
            [rg]="1"
            (newValue)="setA($event)"
            [value]="hslaText.a"
          />
        </div>
        <div class="box">
          <div>H</div>
          <div>S</div>
          <div>L</div>
          <div *ngIf="cpAlphaChannel !== 'disabled'">A</div>
        </div>
      </div>

      <div [hidden]="format !== 1" class="rgba-text">
        <div class="box">
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setR($event)"
            [value]="rgbaText.r"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setG($event)"
            [value]="rgbaText.g"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setB($event)"
            [value]="rgbaText.b"
          />
          <input
            *ngIf="cpAlphaChannel !== 'disabled'"
            [rtColorPickerText]
            type="number"
            pattern="[0-9]+([\.,][0-9]{1,2})?"
            min="0"
            max="1"
            step="0.1"
            [rg]="1"
            (newValue)="setA($event)"
            [value]="rgbaText.a"
          />
        </div>
        <div class="box">
          <div>R</div>
          <div>G</div>
          <div>B</div>
          <div *ngIf="cpAlphaChannel !== 'disabled'">A</div>
        </div>
      </div>

      <div [hidden]="format !== 0" class="hex-text">
        <div class="box">
          <input [rtColorPickerText] (newTextValue)="setHex($event)" [value]="hexText" />
        </div>
        <div class="box">
          <div>Hex</div>
        </div>
      </div>
    </div>

    <rt-icon-button
      variant="plain"
      (click)="formatPolicy()"
      iconName="import-export"
      shape="square"
      class="change-input-type"
    ></rt-icon-button>
  </div>

  <div *ngIf="cpPresetColors && cpPresetColors.length" class="preset-area">
    <hr />

    <div class="preset-label">{{ cpPresetLabel }}</div>

    <div
      *ngFor="let color of cpPresetColors; trackBy: trackBy"
      class="preset-color"
      [style.backgroundColor]="color"
      (click)="setColorFromString(color)"
    ></div>
  </div>

  <div *ngIf="cpOKButton || cpCancelButton" class="button-area">
    <button *ngIf="cpOKButton" type="button" class="{{ cpOKButtonClass }}" (click)="oKColor()">
      {{ cpOKButtonText }}
    </button>
    <button
      *ngIf="cpCancelButton"
      type="button"
      class="{{ cpCancelButtonClass }}"
      (click)="cancelColor()"
    >
      {{ cpCancelButtonText }}
    </button>
  </div>
</div>
